module.exports = __webpack_public_path__ + "static/media/mq.4cd7105e.svg";